import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { FaInstagram, FaFacebookF } from "react-icons/fa";
import "./Navbar.css";
import logo from "../assets/logo.png";

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);
  const toggleMenu = () => setMenuOpen((prev) => !prev);

  return (
    <header className="navbar">
      <div className="container navbar-container">

        {/* LEFT LINKS */}
        <ul className="nav-links left">
          <li><NavLink to="/" end onClick={closeMenu}>Home</NavLink></li>
          <li><NavLink to="/about" onClick={closeMenu}>About</NavLink></li>
          <li><NavLink to="/courses" onClick={closeMenu}>Courses</NavLink></li>
          <li><NavLink to="/why-abacus" onClick={closeMenu}>Why Abacus</NavLink></li>
        </ul>

        {/* LOGO (CLICKABLE) */}
        <div className="logo-box">
          <NavLink to="/" onClick={closeMenu}>
            <img src={logo} alt="SIP Abacus Logo" className="logo-img" />
          </NavLink>
        </div>

        {/* RIGHT LINKS */}
        <ul className="nav-links right">
          <li><NavLink to="/gallery" onClick={closeMenu}>Gallery</NavLink></li>
          <li><NavLink to="/contact" onClick={closeMenu}>Contact</NavLink></li>

          <li className="social social-first">
            <a
              href="https://www.instagram.com/sipabacusmalkajgiri/?hl=en"
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
            >
              <FaInstagram />
            </a>
          </li>

          <li className="social">
            <a
              href="https://www.facebook.com/vanaja.gorantala"
              target="_blank"
              rel="noreferrer"
              aria-label="Facebook"
            >
              <FaFacebookF />
            </a>
          </li>
        </ul>

        {/* HAMBURGER */}
        <button
          className={`hamburger ${menuOpen ? "active" : ""}`}
          onClick={toggleMenu}
          type="button"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* MOBILE MENU */}
        <nav className={`mobile-menu ${menuOpen ? "open" : ""}`}>
          <ul>
            <li><NavLink to="/" end onClick={closeMenu}>Home</NavLink></li>
            <li><NavLink to="/about" onClick={closeMenu}>About</NavLink></li>
            <li><NavLink to="/courses" onClick={closeMenu}>Courses</NavLink></li>
            <li><NavLink to="/why-abacus" onClick={closeMenu}>Why Abacus</NavLink></li>
            <li><NavLink to="/gallery" onClick={closeMenu}>Gallery</NavLink></li>
            <li><NavLink to="/contact" onClick={closeMenu}>Contact</NavLink></li>

            <li className="mobile-social">
              <a
                href="https://www.instagram.com/sipabacusmalkajgiri/?hl=en"
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
              >
                <FaInstagram />
              </a>
              <a
                href="https://www.facebook.com/vanaja.gorantala"
                target="_blank"
                rel="noreferrer"
                aria-label="Facebook"
              >
                <FaFacebookF />
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Navbar;